import { render, staticRenderFns } from "./UIDonutSvgOverlay.vue?vue&type=template&id=e1a18198"
import script from "./UIDonutSvgOverlay.vue?vue&type=script&lang=js"
export * from "./UIDonutSvgOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports